import React from 'react'
import { connect } from 'react-redux'

import PageContent from 'common/PageContent'
import Section from 'common/Section'

import { setTitle } from 'reducers/global'

class NotFound extends React.Component {
  constructor (props) {
    super(props)

    props.dispatch(setTitle('404'))
  }

  render () {
    return (
      <div>
        <PageContent>
          <Section>
            <h1 className='tc norms-24 fw5 mt0'>404 Not Found</h1>
            <p className='tc norms-16'>We couldn't find the page you were looking for.</p>
          </Section>
        </PageContent>
      </div>
    )
  }
}

export default connect()(NotFound)
